export enum MessageCenterPaneTabIndex {
    Focused = '0',
    UnFocused = '-1'
}
